export class RefereeForm {
    creationDate: string
    isConflict: boolean
    isVolunteeredBefore: boolean
    volunteerExperience: string
    isOtherProgram: boolean
    programExperience: string
}